import React, {useEffect, useState} from "react";
import DoanIcon from "../assets/images/icons/ic-doan-transparent.png";
import CsdcIcon from "../assets/images/icons/ic-csdc-transparent.png";
import VtcIcon from "../assets/images/icons/ic-vtconline-transparent.png";
import {FaBars, FaChevronDown, FaChevronUp, FaTimes} from "react-icons/fa";
import {useAppDispatch, useAppSelector} from "../redux/hooks";
import {actionLogout, refreshExchangeTokenThunk, selectEduType, selectUserInfo, selectVillageId} from "../redux/slices/appSlice";
import {useLogin} from "../common/UseLogin";
import {useLocation, useNavigate} from "react-router-dom";
import {ROUTER_PATHS} from "../router/paths";
import {toast} from "react-toastify";
import {redirectAuth} from "../common/RedirectAuth";
import {ENUM_ACCOUNT_TYPE} from "../common/Constants";
import {getRefreshToken} from "../common/Storage";
import {createJwt} from "../common/ClientRequest";

export const Header: React.FC = () => {
    const [isCanLogin] = useLogin();
    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const selUserInfo = useAppSelector(selectUserInfo);
    const selEduType = useAppSelector(selectEduType);
    const selVillageId = useAppSelector(selectVillageId);
    const [isShowMenu, setIsShowMenu] = useState(false);

    useEffect(() => {
        if (isCanLogin === false) {
        } //
        else if (isCanLogin) {
            dispatch(actionLogout());
        }
    }, [isCanLogin])
    useEffect(() => {
        if (selUserInfo?.lstUserPosition === null || selUserInfo?.lstUserPosition?.length === 0) {
            window.location.href = process.env.REACT_APP_IOE_USER
                + "/cap-nhat-thong-tin-moi?selectType=2" + "&redirect_uri="
                + encodeURIComponent(window.location.href.replace(/\?.*$/, ""))
                + "&state=" + createJwt({refresh_token: getRefreshToken() as string});
        }
    }, [selUserInfo])
    useEffect(() => {
        window.scroll({top: 0, behavior: "smooth"});
    }, [location.pathname])

    const handleScrollToContent = (round: number | null) => {
        if (round) {
            if (window.location.pathname !== process.env.PUBLIC_URL) {
                navigate("/");
                setTimeout(() => handleScrollToContent(round), 500);
                return;
            }
            const tag = document.querySelector("#round-" + round);
            if (tag) {
                tag.scrollIntoView({behavior: "smooth", block: "center"});
            }
        } else {
            window.scrollTo({left: 0, top: 0, behavior: "smooth"});
        }
    }
    const handleOnJoinEvent = async () => {
        if ([ENUM_ACCOUNT_TYPE.Student,
            ENUM_ACCOUNT_TYPE.EduManager_School,
            ENUM_ACCOUNT_TYPE.EduManager_Phong
        ].includes(selEduType as any)) {
            if (selVillageId === 1) {
                const {payload} = await dispatch(refreshExchangeTokenThunk(getRefreshToken() as string));
                if (selEduType === ENUM_ACCOUNT_TYPE.Student) {
                    window.location.href = process.env.REACT_APP_IOE_DOMAIN
                        + "/hoc-sinh/danh-sach-ky-thi/ky-thi-dang-dien-ra"
                        + (payload?.code === 0 ? `?code=${payload?.data?.refresh_token}` : "");
                } else {
                    window.location.href = process.env.REACT_APP_IOE_DOMAIN + "/gotest"
                        + (payload?.code === 0 ? `?code=${payload?.data?.refresh_token}` : "");
                }
            } else {
                toast.error("Tài khoản của bạn không nằm trong danh sách được tham gia!");
            }
        } else {
            toast.error("Tài khoản của bạn không nằm trong danh sách được tham gia!");
        }
    }
    const handleRedirectAction = (action: "register" | "login") => {
        redirectAuth(
            action,
            window.location.href.replace(/\?.*$/, "")
        );
    }
    const handleOnTapRank = () => {
        if (selUserInfo) {
            if ([ENUM_ACCOUNT_TYPE.Student,
                ENUM_ACCOUNT_TYPE.EduManager_School,
                ENUM_ACCOUNT_TYPE.EduManager_Phong,
                ENUM_ACCOUNT_TYPE.EduManager_So
            ].includes(selEduType as any)) {
                if (selVillageId === 1) {
                    navigate(ROUTER_PATHS.RANKINGS);
                } else {
                    toast.error("Tài khoản của bạn không nằm trong danh sách được tham gia!");
                }
            } else {
                toast.error("Tài khoản của bạn không nằm trong danh sách được tham gia!");
            }
        } else {
            redirectAuth(
                "login",
                window.location.href.replace(/\?.*$/, "") + ROUTER_PATHS.RANKINGS
            );
        }
    }

    return <header className={"fixed w-full z-10"}>
        <div className={"header-top relative"}
             style={{background: "linear-gradient(270deg, #4DD4FF 47.5%, #4ACAF9 57.48%, #43B0EA 73.68%, #3B90D9 91.14%, #3780D1 98.62%, #316DC6 107.35%)"}}>
            <button className={"absolute top-[.5rem] left-[.5rem] text-[2rem] text-[#105296] xl:hidden"}
                    onClick={() => setIsShowMenu(!isShowMenu)}>
                {isShowMenu ? <FaTimes/> : <FaBars/>}
            </button>
            <div className={"flex flex-row flex-wrap justify-center gap-[1rem] xl:gap-0 xl:max-w-[1280px] mx-auto py-[.25rem] items-center"}>
                <div className={"xl:flex-1 order-1 flex flex-col items-center"}>
                    <p className={"text-white uppercase font-bold text-[.875rem]"}>Đơn vị chỉ đạo</p>
                    <img src={DoanIcon} className={"h-[68px]"} alt=""/>
                </div>
                <div className={"xl:flex-3 order-3 xl:order-2 flex justify-center"}>
                    {/*<img src={TitleImg} className={"h-[68px]"} alt=""/>*/}
                </div>
                <div className={"xl:flex-1 order-2 xl:order-3 self-start"}>
                    <p className={"text-white uppercase font-bold text-[.875rem] text-center"}>Đơn vị tổ chức</p>
                    <div className={"flex items-end gap-[.5rem] justify-center"}>
                        <img src={CsdcIcon} className={"h-[60px]"} alt=""/>
                        <a href="https://vtconline.vn/">
                            <img src={VtcIcon} className={"h-[56px]"} alt=""/>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div className={`bg-white py-[1rem] ${isShowMenu ? "block" : "hidden"} xl:block`}>
            <div className={"xl:max-w-[1280px] mx-auto flex flex-col xl:flex-row justify-between items-center"}>
                <ul className={"w-full xl:w-auto px-[1.25rem] xl:px-0 flex-1 flex flex-col xl:flex-row xl:gap-[1.5rem] text-[#21272A]" +
                    " divide-y xl:divide-none xl:min-h-[56px] xl:items-center"}>
                    <li className={"font-bold cursor-pointer py-[.5rem] xl:py-0" + (location.pathname === "/" ? " text-[#F24B18]" : "")}
                        onClick={() => {
                            if (location.pathname === "/") {
                                handleScrollToContent(null);
                            } else {
                                navigate("/");
                            }
                        }}>Giới thiệu chung
                    </li>
                    <li className={"group"}>
                        <div className={"flex items-center gap-[.5rem] font-bold"}>
                            <p className={"cursor-pointer hover:text-[#F24B18] py-[.25rem] xl:py-0"
                                + ([ROUTER_PATHS.ROUND2, ROUTER_PATHS.ROUND1, ROUTER_PATHS.ROUND3].includes(location.pathname as any) ? " text-[#F24B18]" : "")}>Các
                                vòng thi</p>
                            <FaChevronUp className={"hidden xl:group-hover:block"}/>
                            <FaChevronDown className={"hidden xl:block group-hover:hidden"}/>
                        </div>
                        <div className={"relative xl:absolute xl:bg-white xl:rounded-[.5rem] xl:p-[1rem] transition-opacity duration-300" +
                            " xl:hidden group-hover:block xl:opacity-0 group-hover:opacity-100"}>
                            <ul className={"pl-[1rem] xl:pl-0 divide-y"}>
                                <li className={"py-[.2rem] cursor-pointer hover:text-[#F24B18] uppercase" + (location.pathname === ROUTER_PATHS.ROUND1 ? " text-[#F24B18]" : "")}
                                    onClick={() => handleScrollToContent(1)}>round 1
                                </li>
                                <li className={"py-[.2rem] cursor-pointer hover:text-[#F24B18] uppercase" + (location.pathname === ROUTER_PATHS.ROUND2 ? " text-[#F24B18]" : "")}
                                    onClick={() => handleScrollToContent(2)}>round 2
                                </li>
                                <li className={"py-[.2rem] cursor-pointer hover:text-[#F24B18] uppercase" + (location.pathname === ROUTER_PATHS.ROUND3 ? " text-[#F24B18]" : "")}
                                    onClick={() => handleScrollToContent(3)}>round 3
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li className={"font-bold cursor-pointer hover:text-[#F24B18] py-[.5rem] xl:py-0" + (location.pathname === ROUTER_PATHS.RANKINGS ? " text-[#F24B18]" : "")}
                        onClick={handleOnTapRank}>Bảng xếp hạng
                    </li>
                    {/*<li className={"font-bold cursor-pointer hover:text-[#F24B18] py-[.5rem] xl:py-0" + (location.pathname === ROUTER_PATHS.TIN_TUC ? " text-[#F24B18]" : "")}
                        onClick={() => navigate(ROUTER_PATHS.TIN_TUC)}>Tin tức
                    </li>*/}
                </ul>
                <div>
                    {selUserInfo && <p className={"font-bold text-[#252525] text-end"}>{selUserInfo?.s_username} - {selUserInfo?.pk_user_id}</p>}
                    <ul className={"w-full xl:w-auto flex-1 flex flex-col xl:flex-row xl:gap-4 xl:justify-end"}>
                        <li>
                            <button className={"mx-[1rem] xl:mx-0 bg-[#F24B18]" +
                                " font-bold text-white px-[1.25rem] py-[.725rem] rounded-[.725rem]"}
                                    onClick={() => selUserInfo ? handleOnJoinEvent() : handleRedirectAction("login")}>
                                {selUserInfo ? "Vào thi" : "Tham gia cuộc thi"}
                            </button>
                        </li>
                        {selUserInfo && <li>
                            <button className={"mx-[1rem] xl:mx-0 border-[1px] border-[#F24B18]" +
                                " font-bold text-[#F24B18] px-[1.25rem] py-[.725rem] rounded-[.725rem]"}
                                    onClick={() => {
                                        dispatch(actionLogout());
                                        navigate("/", {replace: true});
                                    }}>Đăng xuất
                            </button>
                        </li>}
                    </ul>
                </div>
            </div>
        </div>
        {/*<Modal open={isShowModalRegister}
               centered
               onCancel={() => dispatch(setShowModalRegister(false))}
               footer={false}
               width={"auto"}
               className={"p-[2.25rem]"}
               modalRender={() => {
                   return <div className={"ant-modal-content"}>
                       <div className={"w-[720px] p-[2.5rem] bg-white rounded-[1rem] relative"}>
                           <button className={"absolute right-[1rem] top-[1rem] w-[1.5rem] h-[1.5rem] bg-[#E5E5E5] rounded-[.75rem] flex flex-col" +
                               " items-center justify-center cursor-pointer"}
                                   onClick={() => dispatch(setShowModalRegister(false))}>
                               <FaTimes className={"text-[#4F4F4F]"}/>
                           </button>
                           <ul className={"flex gap-[1.25rem] items-start"}>
                               <li className={"w-[3.5rem] h-[3.5rem] bg-[#F0F2F5] shrink-[1] flex flex-col items-center justify-center rounded-[.5rem]"}>
                                   <FaCheckCircle className={"text-[#105296] text-[1.5rem]"}/>
                               </li>
                               <li className={"shrink-[100]"}>
                                   <p className={"text-[1.25rem] text-[#252525] font-bold"}>Đăng ký tham gia cuộc thi</p>
                                   <ol className={"text-[.875rem] pt-[.5rem]"}>
                                       <li>Để đăng ký tham gia cuộc thi, em cần đăng nhập vào hệ thống bằng tài khoản GoID của hệ thống GoEdu.</li>
                                       <li>Tài khoản GoID đủ điều kiện đăng ký tham gia cuộc thi là tài khoản chưa từng được sử dụng để đăng nhập học
                                           tập
                                           trên ứng dụng Betia English.
                                       </li>
                                   </ol>
                               </li>
                           </ul>
                           <div className={"mt-[2.5rem]"}>
                               <li className={"flex gap-[1.5rem] text-[.875rem] text-[#252525]"}>
                                   <p className={"flex-1"}>- Nếu đã có tài khoản GoID đáp ứng điều kiện trên {"=>"} Click đăng
                                       nhập</p>
                                   <p className={"flex-1"}>- Nếu chưa có tài khoản GoID, hoặc tài khoản GoID của em đã từng được sử dụng để truy cập
                                       học
                                       trên ứng dụng Betia
                                       English, {"=>"} Click đăng ký để tạo một tài khoản mới</p>
                               </li>
                               <li className={"flex gap-[1.5rem] mt-[1rem]"}>
                                   <button className={"font-bold py-[.75rem] rounded-[.5rem] bg-[#F24B18] text-white w-full flex-1"}
                                           onClick={() => handleRedirectAction("login")}>Đăng nhập
                                   </button>
                                   <button className={"font-bold py-[.75rem] rounded-[.5rem] bg-[#F24B18] text-white w-full flex-1"}
                                           onClick={() => handleRedirectAction("register")}>Đăng ký
                                   </button>
                               </li>
                           </div>
                       </div>
                   </div>
               }}/>
        <Modal
            open={showWaring != null}
            centered
            closable={false}
            footer={false}
            width={"auto"}
            className={"p-[2.25rem]"}
        >

            <div className={"w-[400px] p-[2.5rem] bg-white rounded-[1rem] relative flex flex-col items-center"}>
                <p className={"text-center text-red-500 font-bold"}>{showWaring}</p>
                <button className={"mt-[2rem] text-white font-bold bg-[#F24B18] rounded-[.5rem] py-[.875rem] px-[2rem] cursor-pointer"}
                        onClick={async () => {
                            // await dispatch(actionLogout());
                            handleRedirectAction("login", true);
                        }}>
                    Tôi đã hiểu
                </button>
            </div>

        </Modal>*/}
    </header>
}
